import type { Env } from '@contexts/EnvContext'

const clownfishOnlyUrls = [
  '/blog',
  '/careers',
  '/sitemap',
  '/legal-documents',
  '/plans-business',
  '/kosten-business',
  '/cuentas-business',
  '/tarifs-professionnel',
  '/conti-business',
  '/plans',
  '/konten-vergleichen',
  '/cuentas',
  '/conti',
  '/tarifs',
]

export const shouldReloadDocument = (url: string, env: Env) => {
  const SUPPORTED_CLOWNFISH_URL = [...clownfishOnlyUrls] as string[]

  for (const clownfishUrls of SUPPORTED_CLOWNFISH_URL) {
    if (url.includes(clownfishUrls)) {
      return true
    }
  }

  return false
}
